import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScanResult } from '../../types';

interface ScanResultCardProps {
  scanResult: ScanResult;
  onReset: () => void;
}

const ScanResultCard: React.FC<ScanResultCardProps> = ({ scanResult, onReset }) => {
  const { t } = useTranslation();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9998,
      padding: '20px'
    }}>
      <div style={{
        background: scanResult.success 
          ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
          : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        borderRadius: '24px',
        padding: '40px',
        width: '100%',
        maxWidth: '360px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
      }}>
        <div style={{
          fontSize: '64px',
          marginBottom: '20px'
        }}>
          {scanResult.success ? '✅' : '❌'}
        </div>
        
        <h2 style={{
          fontSize: '24px',
          fontWeight: '800',
          marginBottom: '16px',
          color: '#ffffff'
        }}>
          {scanResult.success ? t('scanner.success') : t('scanner.failed')}
        </h2>
        
        <p style={{
          fontSize: '16px',
          marginBottom: '24px',
          color: '#ffffff',
          opacity: 0.95
        }}>
          {scanResult.message}
        </p>
        
        {scanResult.success && scanResult.cashbackEarned && (
          <div style={{
            background: 'rgba(255, 255, 255, 0.25)',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{
              fontSize: '14px',
              color: '#ffffff',
              marginBottom: '8px',
              opacity: 0.9,
              fontWeight: '600'
            }}>
              {t('scanner.cashbackEarned')}
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: '900',
              color: '#ffffff'
            }}>
              ₹{scanResult.cashbackEarned}
            </div>
          </div>
        )}
        
        {scanResult.success && scanResult.pointsEarned && scanResult.pointsEarned > 0 && (
          <div style={{
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{
              fontSize: '14px',
              color: '#ffffff',
              marginBottom: '8px',
              opacity: 0.9,
              fontWeight: '600'
            }}>
              {t('scanner.pointsEarned')}
            </div>
            <div style={{
              fontSize: '28px',
              fontWeight: '900',
              color: '#ffffff'
            }}>
              {scanResult.pointsEarned} {t('scanner.pts')}
            </div>
          </div>
        )}
        
        <button
          onClick={onReset}
          style={{
            width: '100%',
            padding: '16px',
            fontSize: '16px',
            fontWeight: '700',
            border: '2px solid rgba(255,255,255,0.5)',
            borderRadius: '50px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            color: '#ffffff',
            cursor: 'pointer'
          }}
        >
          {scanResult.success ? t('scanner.scanAnother') : t('scanner.tryAgain')}
        </button>
      </div>
    </div>
  );
};

export default ScanResultCard;


